"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PostMessage = require("../../api/PostMessage");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Tab extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      icon: null,
      iconProp: props.icon
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    const {
      isActive,
      name,
      dropdown,
      index,
      icon
    } = this.props;
    this.props.onClick(this.props.index);
    _PostMessage.PostMessage.postMessageCoreEvent('tab-click', {
      isActive,
      name,
      dropdown,
      index,
      icon
    });
  }
  componentDidMount() {
    this.getIcon();
  }
  getIcon() {
    const {
      iconActive,
      iconInactive,
      isActive
    } = this.props;
    this.setState({
      icon: isActive ? iconActive : iconInactive
    });
  }
  handleMouseOver() {
    const {
      iconActive,
      isActive,
      name,
      dropdown,
      index,
      icon
    } = this.props;
    if (isActive) {
      return;
    }
    this.setState({
      icon: iconActive
    });
    _PostMessage.PostMessage.postMessageCoreEvent('tab-mouseover', {
      isActive,
      name,
      dropdown,
      index,
      icon
    });
  }
  handleMouseLeave() {
    const {
      iconInactive,
      isActive,
      name,
      dropdown,
      index,
      icon
    } = this.props;
    if (isActive) {
      return;
    }
    this.setState({
      icon: iconInactive
    });
    _PostMessage.PostMessage.postMessageCoreEvent('tab-mouseleave', {
      isActive,
      name,
      dropdown,
      index,
      icon
    });
  }
  render() {
    const {
      isActive,
      iconActive,
      iconInactive,
      name,
      dropdown
    } = this.props;
    const {
      icon,
      iconProp
    } = this.state;
    const useSvg = iconActive && iconInactive;
    const materialIcon = iconProp && /*#__PURE__*/_react.default.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons",
      "aria-hidden": "true"
    }, iconProp));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dropdown ? /*#__PURE__*/_react.default.createElement("option", {
      value: name.replace(/\s+/g, '-').toLowerCase()
    }, name) : /*#__PURE__*/_react.default.createElement("li", {
      className: isActive ? 'is-active' : '',
      onMouseEnter: this.handleMouseOver,
      onMouseLeave: this.handleMouseLeave,
      onClick: this.handleClick
    }, /*#__PURE__*/_react.default.createElement("a", null, useSvg ? /*#__PURE__*/_react.default.createElement("img", {
      className: "icon",
      src: icon,
      alt: "",
      role: "presentation"
    }) : materialIcon, /*#__PURE__*/_react.default.createElement("span", null, name))));
  }
}
Tab.propTypes = {
  iconActive: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  iconInactive: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  isActive: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  dropdown: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  index: _propTypes.default.number,
  icon: _propTypes.default.string
};
Tab.defaultProps = {
  isActive: false,
  dropdown: false,
  icon: undefined,
  iconActive: undefined,
  iconInactive: undefined
};
var _default = exports.default = Tab;
//# sourceMappingURL=Tab.js.map